import { Rules } from '@mc-alberta/vee-validate-legacy'

const expiryDate = {
  name: 'expiry_date',
  /**
   * Returns the earliest date that a credit card expiry can be
   *
   * @returns {String} expiry in MM/YY format
   */
  _getMinExpiry() {
    const month = new Date().getMonth() + 1
    const year = parseInt(new Date().getFullYear().toString().substr(-2), 10)

    return `${month}/${year}`.replace(/^([0-9])\//, '0$1/')
  },
  /**
   * Validates that the given expiration is no earlier than the current date.
   *
   * @param {String} value - expiry in MM/YY format
   */
  validator(value) {
    const targetValue = expiryDate._getMinExpiry()

    return Rules.after.validate(value, {
      targetValue,
      inclusion: true,
      format: 'MM/yy'
    })
  }
}

export default expiryDate
